import {
  analyticsEvents,
  ButtonClickedProperties,
  CoverageSearchedProperties,
  EnrollmentReason,
  EnrollmentStepsProceeded,
  PageViewedProperties,
  UserLandedProperties
} from "@/services/analytics/analytics-events"
import { useUserStore } from "@/store/user-store"
import { BaseUser } from "@vitable/asclepius-api-client-ts"

function _getDefaultEventProperties() {
  const userStore = useUserStore()
  return {
    user_id: userStore.user?.id,
    user_type: userStore.user?.user_type
  }
}

function _isInited() {
  // @ts-ignore
  return freshpaint.track
}

function track(event: string, properties?: any) {
  if (!_isInited()) {
    console.log("Freshpaint not inited, but would send the following event:")
    console.log(event)
    console.log("With properties:")
    console.log(properties)
    return
  }

  // @ts-ignore
  freshpaint.track(event, properties)
}

function pageViewed(properties: PageViewedProperties) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.PAGE_VIEWED, properties)
}

function buttonClicked(properties: ButtonClickedProperties) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.BUTTON_CLICKED, properties)
}

function loggedIn(user: BaseUser) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.addEventProperties(_getDefaultEventProperties())
  // @ts-ignore
  freshpaint.identify(user.id, {
    /* user properties */
    name: user.member ? "Member User" : undefined,
    user_id: user.id,
    user_type: user.user_type,
    member_id: user.member?.id,
    preferred_language: user.member?.preferred_language,
    created: user.created
  })
  // @ts-ignore
  freshpaint.track(analyticsEvents.LOG_IN)
}

function loggedOut() {
  if (!useUserStore().isLoggedIn) return
  if (!_isInited()) return

  for (const key of Object.keys(_getDefaultEventProperties())) {
    // @ts-ignore
    freshpaint.removeEventProperty(key)
  }
}

// Customized events from Hygieia
function enrollmentStepProceeded(properties: EnrollmentStepsProceeded) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.ENROLLMENT_STEPS_PROCEEDED, properties)
}

function enrollmentReasonGathered(properties: EnrollmentReason) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.ENROLLMENT_REASON_GATHERED, properties)
}

function userLanded(properties: UserLandedProperties) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.USER_LANDED, properties)
}

function coverageSearched(properties: CoverageSearchedProperties) {
  if (!_isInited()) return

  // @ts-ignore
  freshpaint.track(analyticsEvents.COVERAGE_SEARCHED, properties)
}

export default {
  track,
  pageViewed,
  buttonClicked,
  loggedIn,
  loggedOut,
  enrollmentStepProceeded,
  enrollmentReasonGathered,
  userLanded,
  coverageSearched
}
